import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, ShieldIcon, SmartphoneIcon, MessageSquareIcon, SearchIcon, AwardIcon } from 'lucide-react';
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const bonuses = [{
    icon: BookOpenIcon,
    title: 'Ebook Principal',
    description: 'Estrategias paso a paso para navegar la jerarquía social de Middle y High School.'
  }, {
    icon: ShieldIcon,
    title: 'Protocolo Anti-Vaping & Sustancias',
    description: 'Cómo detectar señales de alerta antes de que sea demasiado tarde.'
  }, {
    icon: SmartphoneIcon,
    title: 'Diccionario de Redes Sociales para Padres',
    description: 'Entiende qué está viendo realmente en TikTok, Snapchat e IG.'
  }, {
    icon: MessageSquareIcon,
    title: 'Scripts de Respuesta Rápida',
    description: "Guiones exactos para que tu hijo diga 'no' sin perder su estatus social."
  }, {
    icon: SearchIcon,
    title: 'Auditoría Digital de 5 Minutos',
    description: 'Cómo supervisar su mundo online sin invadir su privacidad.'
  }, {
    icon: AwardIcon,
    title: "Hoja de Trabajo 'El Escudo de Identidad'",
    description: 'Ejercicios para fortalecer la autoestima de tu hijo frente a la crítica.'
  }];
  return <section ref={ref} className="w-full bg-darker-navy py-16 md:py-20 px-6" data-id="element-120">
      <div className="max-w-6xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-122">
          <h2 className="text-4xl md:text-5xl font-oswald text-gold mb-12 text-center" data-id="element-123">
            Qué Obtienes Hoy
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-dark-navy p-6 rounded-lg border border-cyan/30 hover:border-gold/50 transition-colors" data-id="element-125">
                <bonus.icon className="w-12 h-12 text-cyan mb-4" data-id="element-126" />
                <h3 className="text-xl font-oswald text-white mb-3" data-id="element-127">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-128">
                  {bonus.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}